"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimeSdk = void 0;
const wallet_1 = require("./wallet");
const interfaces_1 = require("./interfaces");
const common_1 = require("./common");
const ethers_1 = require("ethers");
const constants_1 = require("./network/constants");
const base_1 = require("./base");
const dto_1 = require("./dto");
const ZeroDevWalletAPI_1 = require("./base/ZeroDevWalletAPI");
const SimpleAccountWalletAPI_1 = require("./base/SimpleAccountWalletAPI");
const errorHandler_service_1 = require("./errorHandler/errorHandler.service");
class PrimeSdk {
    constructor(walletProvider, optionsLike) {
        var _a;
        this.userOpsBatch = { to: [], data: [], value: [] };
        let walletConnectProvider;
        if ((0, wallet_1.isWalletConnectProvider)(walletProvider)) {
            walletConnectProvider = new wallet_1.WalletConnect2WalletProvider(walletProvider);
        }
        else if (!(0, wallet_1.isWalletProvider)(walletProvider)) {
            throw new common_1.Exception('Invalid wallet provider');
        }
        const { chainId, rpcProviderUrl, } = optionsLike;
        this.chainId = chainId;
        const networkConfig = (0, constants_1.getNetworkConfig)(chainId);
        if (!optionsLike.bundlerRpcUrl) {
            if (!networkConfig)
                throw new common_1.Exception('No bundler Rpc provided');
            optionsLike.bundlerRpcUrl = networkConfig.bundler;
        }
        if (networkConfig) {
            optionsLike.graphqlEndpoint = networkConfig.graphqlEndpoint;
        }
        this.factoryUsed = (_a = optionsLike.factoryWallet) !== null && _a !== void 0 ? _a : interfaces_1.Factory.ETHERSPOT;
        let provider;
        if (rpcProviderUrl) {
            provider = new ethers_1.providers.JsonRpcProvider(rpcProviderUrl);
        }
        else
            provider = new ethers_1.providers.JsonRpcProvider(optionsLike.bundlerRpcUrl);
        let entryPointAddress = '', walletFactoryAddress = '';
        if (constants_1.Networks[chainId]) {
            entryPointAddress = constants_1.Networks[chainId].contracts.entryPoint;
            if (constants_1.Networks[chainId].contracts.walletFactory[this.factoryUsed] == '')
                throw new common_1.Exception('The selected factory is not deployed in the selected chain_id');
            walletFactoryAddress = constants_1.Networks[chainId].contracts.walletFactory[this.factoryUsed];
        }
        if (optionsLike.entryPointAddress)
            entryPointAddress = optionsLike.entryPointAddress;
        if (optionsLike.walletFactoryAddress)
            walletFactoryAddress = optionsLike.walletFactoryAddress;
        if (entryPointAddress == '')
            throw new common_1.Exception('entryPointAddress not set on the given chain_id');
        if (walletFactoryAddress == '')
            throw new common_1.Exception('walletFactoryAddress not set on the given chain_id');
        if (this.factoryUsed === interfaces_1.Factory.ZERO_DEV) {
            this.etherspotWallet = new ZeroDevWalletAPI_1.ZeroDevWalletAPI({
                provider,
                walletProvider: walletConnectProvider !== null && walletConnectProvider !== void 0 ? walletConnectProvider : walletProvider,
                optionsLike,
                entryPointAddress,
                factoryAddress: walletFactoryAddress,
            });
        }
        else if (this.factoryUsed === interfaces_1.Factory.SIMPLE_ACCOUNT) {
            this.etherspotWallet = new SimpleAccountWalletAPI_1.SimpleAccountAPI({
                provider,
                walletProvider: walletConnectProvider !== null && walletConnectProvider !== void 0 ? walletConnectProvider : walletProvider,
                optionsLike,
                entryPointAddress,
                factoryAddress: walletFactoryAddress,
            });
        }
        else {
            this.etherspotWallet = new base_1.EtherspotWalletAPI({
                provider,
                walletProvider: walletConnectProvider !== null && walletConnectProvider !== void 0 ? walletConnectProvider : walletProvider,
                optionsLike,
                entryPointAddress,
                factoryAddress: walletFactoryAddress,
            });
        }
        this.bundler = new base_1.HttpRpcClient(optionsLike.bundlerRpcUrl, entryPointAddress, chainId);
    }
    get state() {
        return this.etherspotWallet.services.stateService;
    }
    get state$() {
        return this.etherspotWallet.services.stateService.state$;
    }
    get supportedNetworks() {
        return this.etherspotWallet.services.networkService.supportedNetworks;
    }
    destroy() {
        this.etherspotWallet.context.destroy();
    }
    async signMessage(dto) {
        const { message } = await (0, dto_1.validateDto)(dto, dto_1.SignMessageDto);
        await this.etherspotWallet.require({
            network: false,
        });
        return this.etherspotWallet.services.walletService.signMessage(message);
    }
    async createSession(dto = {}) {
        const { ttl, fcmToken } = await (0, dto_1.validateDto)(dto, dto_1.CreateSessionDto);
        await this.etherspotWallet.require();
        return this.etherspotWallet.services.sessionService.createSession(ttl, fcmToken);
    }
    async getCounterFactualAddress() {
        return this.etherspotWallet.getCounterFactualAddress();
    }
    async estimate(paymasterDetails, gasDetails) {
        var _a, _b;
        if (this.userOpsBatch.to.length < 1) {
            throw new errorHandler_service_1.ErrorHandler('cannot sign empty transaction batch', 1);
        }
        if (paymasterDetails === null || paymasterDetails === void 0 ? void 0 : paymasterDetails.url) {
            const paymasterAPI = new base_1.VerifyingPaymasterAPI(paymasterDetails.url, this.etherspotWallet.entryPointAddress, (_a = paymasterDetails.context) !== null && _a !== void 0 ? _a : {});
            this.etherspotWallet.setPaymasterApi(paymasterAPI);
        }
        else
            this.etherspotWallet.setPaymasterApi(null);
        const tx = Object.assign({ target: this.userOpsBatch.to, values: this.userOpsBatch.value, data: this.userOpsBatch.data }, gasDetails);
        const partialtx = await this.etherspotWallet.createUnsignedUserOp(Object.assign(Object.assign({}, tx), { maxFeePerGas: 1, maxPriorityFeePerGas: 1 }));
        if (this.factoryUsed === interfaces_1.Factory.ZERO_DEV) {
            partialtx.signature = "0x00000000870fe151d548a1c527c3804866fab30abf28ed17b79d5fc5149f19ca0819fefc3c57f3da4fdf9b10fab3f2f3dca536467ae44943b9dbb8433efe7760ddd72aaa1c";
        }
        const bundlerGasEstimate = await this.bundler.getVerificationGasInfo(partialtx);
        if ((gasDetails === null || gasDetails === void 0 ? void 0 : gasDetails.maxFeePerGas) && (gasDetails === null || gasDetails === void 0 ? void 0 : gasDetails.maxPriorityFeePerGas)) {
            partialtx.maxFeePerGas = gasDetails.maxFeePerGas;
            partialtx.maxPriorityFeePerGas = gasDetails.maxPriorityFeePerGas;
        }
        else if (bundlerGasEstimate.maxFeePerGas && bundlerGasEstimate.maxPriorityFeePerGas) {
            partialtx.maxFeePerGas = bundlerGasEstimate.maxFeePerGas;
            partialtx.maxPriorityFeePerGas = bundlerGasEstimate.maxPriorityFeePerGas;
        }
        else {
            const gas = await this.getGasFee();
            partialtx.maxFeePerGas = gas.maxFeePerGas;
            partialtx.maxPriorityFeePerGas = gas.maxPriorityFeePerGas;
        }
        if (bundlerGasEstimate.preVerificationGas) {
            partialtx.preVerificationGas = ethers_1.BigNumber.from(bundlerGasEstimate.preVerificationGas);
            partialtx.verificationGasLimit = ethers_1.BigNumber.from((_b = bundlerGasEstimate.verificationGasLimit) !== null && _b !== void 0 ? _b : bundlerGasEstimate.verificationGas);
            partialtx.callGasLimit = ethers_1.BigNumber.from(bundlerGasEstimate.callGasLimit);
        }
        return partialtx;
    }
    async getGasFee() {
        const version = await this.bundler.getBundlerVersion();
        if (version.includes('skandha'))
            return this.bundler.getSkandhaGasPrice();
        return (0, common_1.getGasFee)(this.etherspotWallet.provider);
    }
    async send(userOp) {
        const signedUserOp = await this.etherspotWallet.signUserOp(userOp);
        return this.bundler.sendUserOpToBundler(signedUserOp);
    }
    async getNativeBalance() {
        if (!this.etherspotWallet.accountAddress) {
            await this.getCounterFactualAddress();
        }
        const balance = await this.etherspotWallet.provider.getBalance(this.etherspotWallet.accountAddress);
        return ethers_1.ethers.utils.formatEther(balance);
    }
    async getUserOpReceipt(userOpHash) {
        return this.bundler.getUserOpsReceipt(userOpHash);
    }
    async getUserOpHash(userOp) {
        return this.etherspotWallet.getUserOpHash(userOp);
    }
    async addUserOpsToBatch(tx) {
        var _a, _b;
        if (!tx.data && !tx.value)
            throw new errorHandler_service_1.ErrorHandler('Data and Value both cannot be empty', 1);
        if (tx.value && this.factoryUsed === interfaces_1.Factory.SIMPLE_ACCOUNT && tx.value.toString() !== '0' && this.userOpsBatch.value.length > 0)
            throw new errorHandler_service_1.ErrorHandler('SimpleAccount: native transfers cant be part of batch', 1);
        this.userOpsBatch.to.push(tx.to);
        this.userOpsBatch.value.push((_a = tx.value) !== null && _a !== void 0 ? _a : ethers_1.BigNumber.from(0));
        this.userOpsBatch.data.push((_b = tx.data) !== null && _b !== void 0 ? _b : '0x');
        return this.userOpsBatch;
    }
    async clearUserOpsFromBatch() {
        this.userOpsBatch.to = [];
        this.userOpsBatch.data = [];
        this.userOpsBatch.value = [];
    }
    async getAccountContract() {
        return this.etherspotWallet._getAccountContract();
    }
    async totalGasEstimated(userOp) {
        const callGasLimit = ethers_1.BigNumber.from(await userOp.callGasLimit);
        const verificationGasLimit = ethers_1.BigNumber.from(await userOp.verificationGasLimit);
        const preVerificationGas = ethers_1.BigNumber.from(await userOp.preVerificationGas);
        return callGasLimit.add(verificationGasLimit).add(preVerificationGas);
    }
    async getFiatOnRamp(params = {}) {
        var _a;
        if (!params.onlyCryptoNetworks)
            params.onlyCryptoNetworks = constants_1.onRamperAllNetworks.join(',');
        else {
            const networks = params.onlyCryptoNetworks.split(',');
            for (const network in networks) {
                if (!constants_1.onRamperAllNetworks.includes(network))
                    throw new errorHandler_service_1.ErrorHandler('Included Networks which are not supported. Please Check', 1);
            }
        }
        const url = `https://buy.onramper.com/?networkWallets=ETHEREUM:${await this.getCounterFactualAddress()}` +
            `&apiKey=${common_1.onRampApiKey}` +
            `&onlyCryptoNetworks=${params.onlyCryptoNetworks}` +
            `${params.defaultCrypto ? `&defaultCrypto=${params.defaultCrypto}` : ``}` +
            `${params.excludeCryptos ? `&excludeCryptos=${params.excludeCryptos}` : ``}` +
            `${params.onlyCryptos ? `&onlyCryptos=${params.onlyCryptos}` : ``}` +
            `${params.excludeCryptoNetworks ? `&excludeCryptoNetworks=${params.excludeCryptoNetworks}` : ``}` +
            `${params.defaultAmount ? `&defaultCrypto=${params.defaultAmount}` : ``}` +
            `${params.defaultFiat ? `&defaultFiat=${params.defaultFiat}` : ``}` +
            `${params.isAmountEditable ? `&isAmountEditable=${params.isAmountEditable}` : ``}` +
            `${params.onlyFiats ? `&onlyFiats=${params.onlyFiats}` : ``}` +
            `${params.excludeFiats ? `&excludeFiats=${params.excludeFiats}` : ``}` +
            `&themeName=${(_a = params.themeName) !== null && _a !== void 0 ? _a : 'dark'}`;
        if (typeof window === 'undefined') {
            (0, common_1.openUrl)(url);
        }
        else {
            window.open(url);
        }
        return url;
    }
    async getAccountBalances(dto = {}) {
        const { account, tokens, chainId, provider } = await (0, dto_1.validateDto)(dto, dto_1.GetAccountBalancesDto, {
            addressKeys: ['account', 'tokens'],
        });
        await this.etherspotWallet.require({
            wallet: !account,
        });
        const ChainId = chainId ? chainId : this.etherspotWallet.services.walletService.chainId;
        return this.etherspotWallet.services.dataService.getAccountBalances(this.etherspotWallet.prepareAccountAddress(account), tokens, ChainId, provider);
    }
    async getTransaction(dto) {
        const { hash } = await (0, dto_1.validateDto)(dto, dto_1.GetTransactionDto);
        await this.etherspotWallet.require({
            wallet: false,
        });
        return this.etherspotWallet.services.dataService.getTransaction(hash);
    }
    async getNftList(dto) {
        const { account, chainId } = await (0, dto_1.validateDto)(dto, dto_1.GetNftListDto, {
            addressKeys: ['account'],
        });
        await this.etherspotWallet.require({
            wallet: !account,
        });
        const ChainId = chainId ? chainId : this.etherspotWallet.services.walletService.chainId;
        return this.etherspotWallet.services.dataService.getNftList(this.etherspotWallet.prepareAccountAddress(account), ChainId);
    }
    async getExchangeSupportedAssets(dto = {}) {
        const { page, limit, chainId } = await (0, dto_1.validateDto)(dto, dto_1.GetExchangeSupportedAssetsDto);
        const account = await this.getCounterFactualAddress();
        const getChainId = chainId ? chainId : this.etherspotWallet.services.walletService.chainId;
        return this.etherspotWallet.services.dataService.getExchangeSupportedAssets(page, limit, getChainId, account);
    }
    async getExchangeOffers(dto) {
        const { fromTokenAddress, toTokenAddress, fromAmount, fromChainId, showZeroUsd } = await (0, dto_1.validateDto)(dto, dto_1.GetExchangeOffersDto, {
            addressKeys: ['fromTokenAddress', 'toTokenAddress'],
        });
        let { toAddress, fromAddress } = dto;
        if (!fromAddress)
            fromAddress = await this.getCounterFactualAddress();
        if (!toAddress)
            toAddress = fromAddress;
        this.etherspotWallet.services.accountService.joinContractAccount(fromAddress);
        await this.etherspotWallet.require({
            contractAccount: true,
        });
        let { chainId } = this.etherspotWallet.services.walletService;
        chainId = fromChainId ? fromChainId : chainId;
        return this.etherspotWallet.services.dataService.getExchangeOffers(fromTokenAddress, toTokenAddress, ethers_1.BigNumber.from(fromAmount), chainId, toAddress, fromAddress, showZeroUsd);
    }
    async getAdvanceRoutesLiFi(dto) {
        const { fromChainId, toChainId, fromTokenAddress, toTokenAddress, fromAmount, allowSwitchChain, showZeroUsd, } = await (0, dto_1.validateDto)(dto, dto_1.GetAdvanceRoutesLiFiDto, {
            addressKeys: ['fromTokenAddress', 'toTokenAddress'],
        });
        let { toAddress, fromAddress } = dto;
        if (!fromAddress)
            fromAddress = await this.getCounterFactualAddress();
        if (!toAddress)
            toAddress = fromAddress;
        let { chainId } = this.etherspotWallet.services.walletService;
        chainId = fromChainId ? fromChainId : chainId;
        const data = await this.etherspotWallet.services.dataService.getAdvanceRoutesLiFi(fromTokenAddress, toTokenAddress, chainId, toChainId, ethers_1.BigNumber.from(fromAmount), toAddress, allowSwitchChain, fromAddress, showZeroUsd);
        return data;
    }
    async getStepTransaction(dto) {
        const accountAddress = await this.getCounterFactualAddress();
        return this.etherspotWallet.services.dataService.getStepTransaction(dto.route, accountAddress);
    }
    async getCrossChainQuotes(dto) {
        const { fromChainId, toChainId, fromTokenAddress, toTokenAddress, fromAmount, serviceProvider, lifiBridges, toAddress, showZeroUsd, } = await (0, dto_1.validateDto)(dto, dto_1.GetExchangeCrossChainQuoteDto, {
            addressKeys: ['fromTokenAddress', 'toTokenAddress'],
        });
        let { fromAddress } = dto;
        if (!fromAddress)
            fromAddress = await this.getCounterFactualAddress();
        let { chainId } = this.etherspotWallet.services.walletService;
        chainId = fromChainId ? fromChainId : chainId;
        return this.etherspotWallet.services.dataService.getCrossChainQuotes(fromTokenAddress, toTokenAddress, chainId, toChainId, ethers_1.BigNumber.from(fromAmount), serviceProvider, lifiBridges, toAddress, fromAddress, showZeroUsd);
    }
    async getTokenLists() {
        await this.etherspotWallet.require({
            wallet: false,
        });
        return this.etherspotWallet.services.dataService.getTokenLists();
    }
    async getTokenListTokens(dto = {}) {
        const { name } = await (0, dto_1.validateDto)(dto, dto_1.GetTokenListDto);
        await this.etherspotWallet.require({
            wallet: false,
        });
        return this.etherspotWallet.services.dataService.getTokenListTokens(name);
    }
    async fetchExchangeRates(dto) {
        const { tokens, chainId } = dto;
        let data;
        const promises = [];
        const batches = [...Array(Math.ceil(tokens.length / 50))].map(() => tokens.splice(0, 50));
        batches.forEach((batch) => {
            promises.push(this.etherspotWallet.services.dataService.fetchExchangeRates(batch, chainId));
        });
        await Promise
            .allSettled(promises)
            .then((response) => response === null || response === void 0 ? void 0 : response.forEach((result) => {
            var _a;
            if ((result === null || result === void 0 ? void 0 : result.status) === 'fulfilled') {
                !data
                    ? (data = result.value ? result.value : {})
                    : (data.items = ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.items) ? [...data.items, ...result.value.items] : [...data.items]);
            }
        }));
        if (data && data.items && data.items.length) {
            data.error = '';
            data.errored = false;
            data.items = [...new Map(data.items.map(item => [item['address'], item])).values()];
        }
        else {
            data.items = [];
        }
        return data;
    }
}
exports.PrimeSdk = PrimeSdk;
